<template>
  <section>
    <div v-if="!rewardsIdeas || !rewardsIdeas.length">
      <empty-module
        :title="'You do not have any reward ideas created yet.'"
        :icon="'contact_support'"
      />
    </div>
    <template v-else>
      <div v-for="(rewardType, index) in rewardsByType" :key="index">
        <div v-if="rewardType.rewards && rewardType.rewards.length" class="mb-3">
          <h5 class="text-main2">{{ rewardType.title }}</h5>
          <div class="list--container p-2 border-muted">
            <reward-card
              v-for="(reward, index) in rewardType.rewards"
              :key="index"
              :rewardData="reward"
              @duplicate-select-change="handleRewardsSelected($event, reward)"
            />
          </div>
        </div>
      </div>
    </template>
  </section>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import EmptyModule from '@/components/general/emptyModule.vue';
import RewardCard from './parent/rewardCard.vue';

const REWARD_TYPES = {
  daily: 'daily',
  longTerm: 'long_term',
};

export default {
  components: { RewardCard, EmptyModule },
  data() {
    return {
      rewardsSelected: [],
    };
  },
  computed: {
    ...mapGetters('rewards', ['rewardsIdeas']),
    rewardsByType() {
      return {
        1: {
          title: 'Daily Rewards',
          rewards: this.rewardsIdeas.filter((reward) => reward.reward_type === REWARD_TYPES.daily),
        },
        2: {
          title: 'Big Rewards',
          rewards: this.rewardsIdeas.filter(
            (reward) => reward.reward_type === REWARD_TYPES.longTerm,
          ),
        },
      };
    },
  },
  methods: {
    ...mapMutations('rewards', ['setIsDuplicateActivate']),
    handleRewardsSelected(isSelected, reward) {
      let _currentRewards = [...this.rewardsSelected];

      if (isSelected) {
        _currentRewards.push(reward);
      } else {
        _currentRewards = _currentRewards.filter(({ id }) => id !== reward.id);
      }

      this.rewardsSelected = _currentRewards;
      this.$emit('OnSelectRewards', this.rewardsSelected);
    },
  },
  mounted() {
    this.setIsDuplicateActivate(true);
  },
  beforeDestroy() {
    this.setIsDuplicateActivate(false);
  },
};
</script>
<style lang="scss">
.list--container {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}
</style>
